import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from '@material-ui/lab/Skeleton';
import { updateBackdropState } from 'actions/admin/config';

let timer;

// Shown while a page is being loaded: the shape of a page (a title, a few cards, a table) as shimmering skeleton blocks over the
// content area, so the menu and header stay usable. It closes itself after a few seconds, as the old spinner did.
export default function AppBackdrop({ isOpen = false }) {
  const isBackdropOpen = useSelector(state => state.config.isBackdropOpen);
  const dispatch = useDispatch();

  useEffect(() => {
    timer = setTimeout(() => {
      if (isBackdropOpen || isOpen) {
        dispatch(updateBackdropState(false));
      }
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [isBackdropOpen, isOpen]);

  if (!(isBackdropOpen || isOpen)) return null;
  return (
    <div className="content" aria-busy="true" aria-label="Loading">
      <Skeleton variant="text" width="30%" height={34} animation="wave" />
      <div style={{ display: 'flex', gap: 16, margin: '12px 0 20px' }}>
        {[0, 1, 2].map(i => (
          <Skeleton key={i} variant="rect" height={90} animation="wave" style={{ flex: 1, borderRadius: 12 }} />
        ))}
      </div>
      <Skeleton variant="rect" height={46} animation="wave" style={{ borderRadius: 8, marginBottom: 10 }} />
      {[0, 1, 2, 3, 4].map(i => (
        <Skeleton key={i} variant="rect" height={38} animation="wave" style={{ borderRadius: 6, marginBottom: 8 }} />
      ))}
    </div>
  );
}
